const wysiwygSx = (theme, { drawerWidth = 0 } = {}) => ({
    container: {
        display: 'flex',
        alignItems: 'stretch',
        gap: '16px',
        width: '100%',
        height: 'calc(100vh - 220px)',
        margin: '0 auto 8px auto',
    },
    editorWrapper: {
        flex: 1,
        minWidth: 0,
        height: '100%',
    },
    editor: {
        width: '100%',
        height: '100%',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            position: 'relative',
            top: 'auto',
            right: 'auto',
            height: '100%',
            width: drawerWidth,
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            overflowX: 'hidden',
            overflowY: 'hidden',
            borderLeft: `1px solid ${theme.palette.divider}`,
        },
    },
    drawerHeader: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        p: 1,
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    drawerContent: {
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        p: 2,
    },
    drawerCollapsedContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        p: 1,
    },
    verticalTemplatesText: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '70%',
        width: '100%',
        fontWeight: 600,
        fontSize: 'clamp(11px, 1.1vw, 18px)',
        lineHeight: 1,
        letterSpacing: '0.08em',
        textAlign: 'center',
        color: '#8a8a8a',
    },
    templateLetter: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        transform: 'rotate(90deg)',
    },
});

export default wysiwygSx;
